import { Cake, Search, Users } from "lucide-react";

export const StudentFilter = ({
  classrooms,
  setClassRoomFilter,
  classRoomFilter,
  setClassRoomFilterId,
  classRoomFilterId,
  setSearchTerm,
  filterByBirthday,
  setFilterByBirthday,
}: any) => {
  return (
    <div className="mx-auto mt-6 mb-4 w-[96%] rounded-2xl border border-slate-200 bg-white p-3 shadow-sm">
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-[minmax(220px,280px)_auto_minmax(260px,1fr)] lg:items-center">
        <label className="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-slate-600 focus-within:border-[#0096D1] focus-within:bg-white">
          <Users size={18} className="text-[#012063]" />
          <select
            onChange={(e) => {
              const selectedId = e.target.value;

              if (selectedId === "") {
                setClassRoomFilter("");
                setClassRoomFilterId("");
                return;
              }

              const selectedClass = classrooms.find(
                (c: any) => String(c.id) === selectedId,
              );
              setClassRoomFilter(selectedClass?.name || "");
              setClassRoomFilterId(selectedId);
            }}
            className="w-full bg-transparent text-sm font-semibold text-slate-700 outline-none"
            value={classRoomFilterId || ""}
          >
            <option value="">All Classrooms</option>
            {classrooms?.map((clas: any) => (
              <option key={clas.id} value={clas.id}>
                {clas.name}
              </option>
            ))}
          </select>
        </label>

        <label
          className={`flex min-h-[46px] cursor-pointer items-center justify-between gap-3 rounded-xl border px-3 py-2.5 text-sm font-semibold transition-colors ${
            filterByBirthday
              ? "border-[#0096D1] bg-[#0096D1]/10 text-[#012063]"
              : "border-slate-200 bg-slate-50 text-slate-600 hover:bg-white"
          }`}
        >
          <input
            type="checkbox"
            className="sr-only"
            checked={filterByBirthday}
            onChange={() => setFilterByBirthday(!filterByBirthday)}
          />
          <span className="flex items-center gap-2">
            <Cake size={18} className="text-[#0096D1]" />
            Birthday Today
          </span>
          <span
            className={`h-5 w-9 rounded-full p-0.5 transition-colors ${
              filterByBirthday ? "bg-[#0096D1]" : "bg-slate-300"
            }`}
          >
            <span
              className={`block h-4 w-4 rounded-full bg-white transition-transform ${
                filterByBirthday ? "translate-x-4" : "translate-x-0"
              }`}
            />
          </span>
        </label>

        <label className="flex min-h-[46px] items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-slate-600 focus-within:border-[#0096D1] focus-within:bg-white">
          <Search size={18} className="text-[#012063]" />
          <input
            id="searchAttendanceInput"
            onChange={(e: any) => setSearchTerm(e.target.value)}
            placeholder="Search pupil name"
            className="w-full bg-transparent text-sm font-semibold text-slate-700 outline-none placeholder:text-slate-400"
            type="text"
          />
        </label>
      </div>
    </div>
  );
};
